
import actions from './trace.actions';
import mutations from './trace.mutations';
import getters from './trace.getters';

interface Option {
  key: string;
  label: string;
}

interface Trace {
  duration: number;
  isError: boolean;
  key: string;
  operationNames: string[];
  start: string;
  traceIds: string[];
}

interface Span {
  duration: number;
  isError: boolean;
  key: string;
  operationNames: string[];
  start: string;
  traceIds: string[];
}

export interface State {
  services: Option[];
  endpoints: Option[];
  instances: Option[];
  traceForm: any;
  traceList: Trace[];
  traceTotal: number;
  traceSpans: Span[];
  currentTrace: Trace;
  redirectTrace: any;
  showMethodTrace: boolean;
  pdfTraceSpans: Span[];
  selectedTraceLoading: boolean;
  traceLogExists: boolean;
  currentTraceId: string;
}

const initState: State = {
  services: [],
  endpoints: [],
  instances: [],
  traceForm: {
    paging: { pageNum: 1, pageSize: 10, needTotal: true },
    queryOrder: localStorage.getItem('traceQueryOrder') || 'BY_DURATION'
  },
  traceList: [],
  traceTotal: 0,
  traceSpans: [],
  currentTrace: {
    operationNames: [],
    duration: 0,
    isError: false,
    key: '',
    start: '',
    traceIds: []
  },
  redirectTrace: {},
  showMethodTrace: false,
  pdfTraceSpans: [],
  selectedTraceLoading: false,
  traceLogExists: false,
  currentTraceId: ''
};

export default {
  namespaced: true,
  state: initState,
  getters,
  actions: actions,
  mutations: mutations
};
